<template>
    <div class="bg p-3 pb-6">
        <div class="form-columns-fit mb-4">
            <div class="columns is-flex-wrap">
                <div class="column is-half is-full-mobile">
                    <verified-date-picker
                        dateType="startDate"
                        :value="dataInicial"
                        :endDate="dataFinal"
                        title="data-inicio"
                        @input="changeStartDate"
                        :showClean="false"
                        :invalid="dataInicial == null"
                    />
                </div>
                <div class="column is-half is-full-mobile">
                    <verified-date-picker
                        dateType="endDate"
                        :value="dataFinal"
                        :startDate="dataInicial"
                        title="data-fim"
                        @input="changeEndDate"
                        :showClean="false"
                        :invalid="dataFinal == null"
                    />
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        title="cliente"
                        :value="clienteSelected"
                        :options="clienteList"
                        :loading="clienteLoading"
                        @search="carregarClientes"
                        @input="updateCliente"
                        label="rsocial"
                        :closeOnSelect="false"
                        multiple
                        clearable
                        searchable
                    >
                        <template #multiple-selected="{ selected }">
                            ({{
                                selected && selected.length > 0
                                    ? selected.length
                                    : $t('todos')
                            }})
                        </template>
                    </vss-select>
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        title="lps"
                        :value="lpsSelected"
                        :options="lpsList"
                        :loading="lpsLoading"
                        @search="carregarLps"
                        @input="updateLps"
                        label="nome"
                        :closeOnSelect="false"
                        multiple
                        clearable
                        searchable
                    >
                        <template #multiple-selected="{ selected }">
                            ({{
                                selected && selected.length > 0
                                    ? selected.length
                                    : $t('todos')
                            }})
                        </template>
                    </vss-select>
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        title="produto"
                        :value="produtoSelected"
                        :options="produtoList"
                        :loading="produtoLoading"
                        @search="carregarProduto"
                        @input="updateProduto"
                        label="descricao"
                        :closeOnSelect="false"
                        multiple
                        clearable
                        searchable
                    >
                        <template #multiple-selected="{ selected }">
                            ({{
                                selected && selected.length > 0
                                    ? selected.length
                                    : $t('todos')
                            }})
                        </template>
                    </vss-select>
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        ref="withTrocaSelect"
                        :searchable="false"
                        :options="withTrocaSelect"
                        v-model="withTrocaSelected"
                        mlLabels
                        title="com-troca"
                        @input="updateWithTroca"
                    />
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        ref="withDepositoSelect"
                        :searchable="false"
                        :options="withDepositoSelect"
                        v-model="withDepositoSelected"
                        mlLabels
                        title="com-deposito"
                        @input="updateWithDeposito"
                    />
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        ref="withAreaVendaSelect"
                        :searchable="false"
                        :options="withAreaVendaSelect"
                        v-model="withAreaVendaSelected"
                        mlLabels
                        title="com-area-venda"
                        @input="updateWithAreaVenda"
                    />
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        ref="withFotoSelect"
                        :searchable="false"
                        :options="withFotoSelect"
                        v-model="withFotoSelected"
                        mlLabels
                        title="com-foto"
                        @input="updateWithFoto"
                    />
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        ref="withRupturaSelect"
                        :searchable="false"
                        :options="withRupturaSelect"
                        v-model="withRupturaSelected"
                        mlLabels
                        title="com-ruptura"
                        @input="updateWithRuptura"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        filtersReset: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            dataInicial: new Date(this.$moment().subtract(30, 'days')),
            dataFinal: new Date(),

            clienteList: [],
            clienteSelected: [],
            clienteLoading: false,

            lpsList: [],
            lpsSelected: [],
            lpsLoading: false,

            produtoList: [],
            produtoSelected: [],
            produtoLoading: false,

            withTrocaSelect: [
                { label: 'todos', id: 0 },
                { label: 'sim', id: 1 },
                { label: 'nao', id: 2 }
            ],
            withTrocaSelected: { label: 'todos', id: 0 },

            withDepositoSelect: [
                { label: 'todos', id: 0 },
                { label: 'sim', id: 1 },
                { label: 'nao', id: 2 }
            ],
            withDepositoSelected: { label: 'todos', id: 0 },

            withAreaVendaSelect: [
                { label: 'todos', id: 0 },
                { label: 'sim', id: 1 },
                { label: 'nao', id: 2 }
            ],
            withAreaVendaSelected: { label: 'todos', id: 0 },

            withFotoSelect: [
                { label: 'todos', id: 0 },
                { label: 'sim', id: 1 },
                { label: 'nao', id: 2 }
            ],
            withFotoSelected: { label: 'todos', id: 0 },

            withRupturaSelect: [
                { label: 'todos', id: 0 },
                { label: 'sim', id: 1 },
                { label: 'nao', id: 2 }
            ],
            withRupturaSelected: { label: 'todos', id: 0 },
        }
    },
    watch: {
        filtersReset(val) {
            if (val) this.clearFilter();
        },
    },
    methods: {
        changeStartDate(date) {
            if (date.getTime() != this.dataInicial.getTime()) {
                this.dataInicial = date;
                if (!this.isNull(this.dataInicial)) {
                    this.$emit('update-filtro', {
                        nomeFiltro: 'dataInicial',
                        valor: this.dataInicial,
                    })
                }
            }
        },
        changeEndDate(date) {
            if (date.getTime() != this.dataFinal.getTime()) {
                this.dataFinal = date;
                if (!this.isNull(this.dataFinal)) {
                    this.$emit('update-filtro', {
                        nomeFiltro: 'dataFinal',
                        valor: this.dataFinal,
                    })
                }
            }
        },
        carregarClientes(searchQuery) {
            this.clienteLoading = true;
            this.$axios
                .get(`/promotor/cliente/getcombo.json`, {
                    params: {
                        param: searchQuery
                    }
                })
                .then((response) => {
                    if (response.status != 200) {
                        console.error(`[RUPTURA] Erro status ${r.status} ao carregar clientes.`);
                        console.error(`[RUPTURA] Mensagem: ${r.message}`);
                    } else {
                        this.clienteList = response.data.content.map((c) => {
                            return {
                                id: c.idcliente,
                                rsocial: c.rsocial,
                            };
                        });
                    }
                })
                .catch((e) => {
                    this.clienteList = [];
                    console.error('[RUPTURA] Erro ao carregar clientes.', e);
                })
                .finally((_) => {
                    this.clienteLoading = false;
                });
        },
        updateCliente(cliente) {
            this.clienteSelected = cliente;
            this.$emit('update-filtro', {
                nomeFiltro: 'idClienteList',
                valor:
                    this.clienteSelected.length == 0 ? [] : this.clienteSelected.map((c) => c.id),
            })
        },
        carregarLps(searchQuery) {
            this.lpsLoading = true;
            this.$axios
                .get(`/promotor/getcombo/lps.json`, {
                    params: {
                        param: searchQuery
                    }
                })
                .then((response) => {
                    if (response.status != 200) {
                        console.error(`[RUPTURA] Erro status ${r.status} ao carregar lps.`);
                        console.error(`[RUPTURA] Mensagem: ${r.message}`);
                    } else {
                        this.lpsList = response.data.content.map((l) => {
                            return {
                                id: l.idlps,
                                nome: l.nome,
                            };
                        });
                    }
                })
                .catch((e) => {
                    this.lpsList = [];
                    console.error('[RUPTURA] Erro ao carregar lps.', e);
                })
                .finally((_) => {
                    this.lpsLoading = false;
                });
        },
        updateLps(lps) {
            this.lpsSelected = lps;
            this.$emit('update-filtro', {
                nomeFiltro: 'idLpsList',
                valor:
                    this.lpsSelected.length == 0 ? [] : this.lpsSelected.map((l) => l.id),
            })
        },
        carregarProduto(searchQuery) {
            this.produtoLoading = true;
            this.$axios
                .get(`/promotor/getcombo/produto.json`, {
                    params: {
                        param: searchQuery
                    }
                })
                .then((response) => {
                    if (response.status != 200) {
                        console.error(`[RUPTURA] Erro status ${r.status} ao carregar produtos.`);
                        console.error(`[RUPTURA] Mensagem: ${r.message}`);
                    } else {
                        this.produtoList = response.data.content.map((p) => {
                            return {
                                id: p.idproproduto,
                                descricao: p.descricao,
                            };
                        });
                    }
                })
                .catch((e) => {
                    this.produtoList = [];
                    console.error('[RUPTURA] Erro ao carregar produtos.', e);
                })
                .finally((_) => {
                    this.produtoLoading = false;
                });
        },
        updateProduto(produto) {
            this.produtoSelected = produto;
            this.$emit('update-filtro', {
                nomeFiltro: 'idProdutoList',
                valor:
                    this.produtoSelected.length == 0 ? [] : this.produtoSelected.map((p) => p.id),
            })
        },
        clearFilter() {
            this.dataInicial = new Date(this.$moment().subtract(30, 'days'));
            this.dataFinal = new Date();
            this.clienteSelected = [];
            this.lpsSelected = [];
            this.produtoSelected = [];
            this.withTrocaSelected = { label: 'todos', id: 0 };
            this.withDepositoSelected = { label: 'todos', id: 0 };
            this.withAreaVendaSelected = { label: 'todos', id: 0 };
            this.withFotoSelected = { label: 'todos', id: 0 };
            this.withRupturaSelected = { label: 'todos', id: 0 };
        },
        updateWithTroca(withTroca) {
            this.withTrocaSelected = withTroca
                ? this.withTrocaSelect.filter((wt) => wt.id == withTroca.id)[0]
                : this.withTrocaSelect[0];
            this.$emit('update-filtro', {
                nomeFiltro: 'withTroca',
                valor: this.withTrocaSelected.id,
            })
        },
        updateWithDeposito(withDeposito) {
            this.withDepositoSelected = withDeposito
                ? this.withDepositoSelect.filter((wt) => wt.id == withDeposito.id)[0]
                : this.withDepositoSelect[0];
            this.$emit('update-filtro', {
                nomeFiltro: 'withDeposito',
                valor: this.withDepositoSelected.id,
            })
        },
        updateWithAreaVenda(withAreaVenda) {
            this.withAreaVendaSelected = withAreaVenda
                ? this.withAreaVendaSelect.filter((wt) => wt.id == withAreaVenda.id)[0]
                : this.withAreaVendaSelect[0];
            this.$emit('update-filtro', {
                nomeFiltro: 'withAreaVenda',
                valor: this.withAreaVendaSelected.id,
            })
        },
        updateWithFoto(withFoto) {
            this.withFotoSelected = withFoto
                ? this.withFotoSelect.filter((wt) => wt.id == withFoto.id)[0]
                : this.withFotoSelect[0];
            this.$emit('update-filtro', {
                nomeFiltro: 'withFoto',
                valor: this.withFotoSelected.id,
            })
        },
        updateWithRuptura(withRuptura) {
            this.withRupturaSelected = withRuptura
                ? this.withRupturaSelect.filter((wt) => wt.id == withRuptura.id)[0]
                : this.withRupturaSelect[0];
            this.$emit('update-filtro', {
                nomeFiltro: 'withRuptura',
                valor: this.withRupturaSelected.id,
            })
        },
    }
}
</script>
